import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import supabase from '../../utils/supabaseClient';

/**
 * ResourceAdminMenu component - Navigation menu for resource admin pages
 * Only shown to users with admin privileges
 */
const ResourceAdminMenu = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { user } = useAuth();
  
  // Check if user is admin
  const checkAdminStatus = useCallback(async () => {
    if (!user) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }
    
    try {
      const { data, error } = await supabase
        .from('user_profiles')
        .select('subscription_status')
        .eq('user_id', user.id)
        .single();
        
      if (!error && data) {
        setIsAdmin(data.subscription_status === 'admin');
      } else {
        setIsAdmin(false);
      }
    } catch (error) {
      console.error('Error checking admin status:', error);
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  }, [user]);
  
  useEffect(() => {
    checkAdminStatus();
  }, [checkAdminStatus]);
  
  // If not admin or still loading, don't render anything
  if (loading || !isAdmin) {
    return null;
  }
  
  // Check if the current path is active
  const isActive = (path) => {
    return location.pathname.includes(path);
  };
  
  return (
    <div className="bg-gray-100 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-500 mr-4">
              Resource Admin:
            </span>
            <nav className="flex space-x-4">
              <Link
                to="/resources/manage"
                className={`px-3 py-2 text-sm font-medium rounded-md ${
                  isActive('/resources/manage')
                    ? 'bg-primary-100 text-primary-800'
                    : 'text-gray-600 hover:bg-gray-200'
                }`}
              >
                Manage Resources
              </Link>
              <Link
                to="/resources/categories"
                className={`px-3 py-2 text-sm font-medium rounded-md ${
                  isActive('/resources/categories')
                    ? 'bg-primary-100 text-primary-800'
                    : 'text-gray-600 hover:bg-gray-200'
                }`}
              >
                Categories
              </Link>
              <Link
                to="/resources/new"
                className={`px-3 py-2 text-sm font-medium rounded-md ${
                  isActive('/resources/new')
                    ? 'bg-primary-100 text-primary-800'
                    : 'text-gray-600 hover:bg-gray-200'
                }`}
              >
                Add New Resource
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourceAdminMenu; 